import React from 'react'

import {BrowserRouter as Router, Routes, Route} from "react-router-dom"


//NAV IMPORT
import Navbar from './Navbar/Navbar';

//PAGE IMPORT 
import Home from "./pages/home/Home"
import Products from './pages/products/Products';
import About from "./pages/about/About"
import Blogs from "./pages/blogs/Blogs"



//AUTH Import 
import Register from './Register/Register';
import Login from './Register/Login'
import Contact from './pages/contact/contact';
import Faq from './pages/faq/faq'
import Footer from './Footer/Footer';

function Main() {
  return (
   <Router>
    {/* <Navbar/> */}
    <Routes>
        <Route exact path='/' element={<Home/>}/> 
        <Route path='/products' element={<Products/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/blogs' element={<Blogs/>}/>
        <Route path='/support' element={<Faq/>}/>
        <Route path='/contact' element={<Contact/>}></Route>
        <Route path='/register' element={<Register/>}/>
        <Route path='/login' element={<Login/>}/>
    </Routes>
    {/* <Footer /> */}
   </Router>
  )
}

export default Main
